import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import SetArchive from './pages/SetArchive';
import Store from './pages/Store';
import Cart from './pages/Cart';
import TheVault from './pages/TheVault';
import ContactUs from './pages/ContactUs';
import OrderSuccess from './pages/OrderSuccess';
import VaultDetail from './components/VaultDetail';
import ScrollToTop from './components/ScrollToTop';
import StoreDetail from './components/StoreDetail';
import './App.css';

function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/set-archive" element={<SetArchive />} />
            <Route path="/store" element={<Store />} />
            <Route path="/store/:productId" element={<StoreDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/the-vault" element={<TheVault />} />
            <Route path="/vault/:eventId" element={<VaultDetail />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/order-success" element={<OrderSuccess />} />
          </Routes>
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
